<template>
  <div class="order-wrapper">
    <portal target-el="#filter">
      <div class="sub-header">
        <div class="header-item">
          <Breadcrumb type="flex" separator-class="el-icon-arrow-right">
            <breadcrumb-item>
              <span @click="routeToIndentList">
                Indents
              </span>
            </breadcrumb-item>
            <breadcrumb-item>Exception</breadcrumb-item>
          </Breadcrumb>
        </div>
        <div class="header-item ml-10">
          <div class="pointer" @click="onClick">
            <svgicon name="search" width="15" height="15" :original="true" />
            {{ searchText }}
          </div>
          <SearchPopup
            v-if="showPopup"
            :searchParameters="searchParameters"
            :presearchedParams="searchedParams"
            @closePopup="closePopup"
            @search="searchByParameter"
            class="searchsec"
          />
          <div class="searchterm tagblock" v-else-if="!noParams" @click="onClick"
            :class="{ pointer: noParams }">
            <span type="text" class="tagblock_list">
              <span v-for="(value, name, index) in searchedParams" :key="index">
                <span v-if="value">
                  <Tag closable @close="removeParamTag(name)">
                    <div class="searchtag-title"> {{ getTagByName(name) }} </div>
                    <Ellipsis
                    :text="value"
                    :length="7"/>
                  </Tag>
                </span>
              </span>
            </span>
          </div>
        </div>
      </div>
    </portal>
    <div>
      <head-panel
        :isLisLoadingCompleted="isLisLoadingCompleted"
        @filter-change="filterChange"
      />
      <exception-list
        :exceptionType = "exceptionType"
        :data="getCategorizedList"
        :isLisLoadingCompleted="isLisLoadingCompleted"
        @select-item="selectItem"
        @load-more="loadData"/>
      <div class="panel-card card-lg clearfix">
        <exception-slider
          :columnType = "exceptionType"
          :entityData="entityDetails"
          :metaData="selectedEntity"
          ref="exception-slider"
        />
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
// eslint-disable-next-line import/no-extraneous-dependencies
import SearchPopup from '@common/components/SearchPopup';
import HeadPanel from '@common/components/HeadPanel';
import { searchParameters, EXCEPTION_TYPE } from '@/constants/exception-data';
import ExceptionSlider from './ExceptionSlider';
import ExceptionList from './ExceptionList';


export default {
  components: {
    HeadPanel,
    ExceptionList,
    ExceptionSlider,
    SearchPopup,
  },
  data() {
    return {
      exceptionList: [],
      exceptionType: 2,
      exceptionCategory: null,
      exceptionCloumn: '',
      exceptionDates: '',
      selectedEntity: {},
      entityDetails: null,
      page: 1,
      emptyData: false,
      searchParameters,
      showPopup: false,
      isLisLoadingCompleted: true,
      searchedParams: {
        source: null,
        destination: null,
        material_invoice_value: null,
        indent_number: null,
      },
    };
  },
  computed: {
    searchText() {
      if (this.noParams && !this.showPopup) {
        return this.$t('INDENT_SEARCH');
      }
      return '';
    },
    noParams() {
      return Object.values(this.searchedParams).every(
        parameter => !parameter,
      );
    },
    getCountDetails() {
      const totalCounts = {
        total: {
          indents: 100,
          deliveries: 14,
        },
        indents: {
          indents: 100,
          deliveries: 14,
        },
      };
      return totalCounts;
    },
    getCategorizedList() {
      return this.exceptionList.map(exception => ({
        ...exception,
        expected_delivery_date: moment(exception.expected_delivery_date).format('MMM Do YYYY  - hh:mm A'),
      }));
    },
  },
  created() {
    this.loadSearchFromSession();
  },
  methods: {
    getTagByName(name) {
      let tagConstant = this.searchParameters.find((param) => {
        if (param.multiDropDownQueryOptions) {
          return param.multiDropDownQueryOptions.find(
            val => val.query === name,
          );
        }
        return param.query === name;
      });
      if (tagConstant && tagConstant.multiDropDownQueryOptions) {
        tagConstant = tagConstant.multiDropDownQueryOptions.find(
          val => val.query === name,
        );
      }
      const tagName = tagConstant && tagConstant.name;
      const tagTranslateName = tagConstant && tagConstant.tname;
      return tagTranslateName ? this.$t(tagTranslateName) : tagName;
    },
    unCheck(value) {
      this[value] = null;
    },
    async removeParamTag(tag) {
      this.unCheck(tag);
      this.searchedParams[tag] = null;
      this.searchedParams = { ...this.searchedParams };
      await this.searchByParameter(this.searchedParams);
    },
    async loadData() {
      this.isLisLoadingCompleted = false;
      if (!this.emptyData) {
        const params = {};
        let dateObj = null;
        if (this.searchedParams && Object.keys(this.searchedParams).length) {
          Object.assign(params, { ...this.searchedParams });
        }
        if (
          this.exceptionDates &&
          this.exceptionDates.length &&
          this.exceptionDates.length === 2
        ) {
          dateObj = {
            start_date: this.exceptionDates[0],
            end_date: this.exceptionDates[1],
          };
        }
        let result = [];
        if (this.exceptionType === EXCEPTION_TYPE.INEGRATION) {
          result = await this.$store.dispatch(
            'order/getIntegrationData',
            {
              page: this.page,
              dateObj,
              params,
            },
          );
        } else {
          result = await this.$store.dispatch(
            'order/getExceptionData',
            {
              page: this.page,
              type: this.exceptionType,
              category: this.exceptionCategory,
              dateObj,
              params,
            },
          );
        }
        if (result.length !== 0) {
          this.exceptionList = [...this.exceptionList, ...result];
          this.page += 1;
          this.emptyData = false;
        } else {
          this.emptyData = true;
          this.entityDetails = null;
        }
      }
      this.isLisLoadingCompleted = true;
    },
    closePopup() {
      this.showPopup = false;
    },
    loadSearchFromSession() {
      const sessionSearchParamsJSON = localStorage.getItem(`${this.$route.name}-search-popup`) || '{}';
      const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
      this.searchedParams = Object.assign({}, this.searchedParams, sessionSearchParams);
    },
    saveSearchToSession() {
      const sessionSearch = JSON.stringify(this.searchedParams);
      localStorage.setItem(`${this.$route.name}-search-popup`, sessionSearch);
    },
    async searchByParameter(data) {
      this.searchedParams = data;
      this.saveSearchToSession();
      this.page = 1;
      this.emptyData = false;
      this.exceptionList = [];
      this.closePopup();
      await this.loadData();
    },
    onClick() {
      this.showPopup = true;
    },
    async filterChange({ type, category, dates, columnMap }) {
      this.exceptionType = type;
      this.exceptionCategory = category;
      this.exceptionDates = dates;
      this.exceptionCloumn = columnMap;
      this.page = 1;
      this.emptyData = false;
      this.exceptionList = [];
      this.entityDetails = null;
      this.$refs['exception-slider'].activeTab = '2'; // To set default tab to Material Exception on section change
      await this.loadData();
    },
    async selectItem(entity) {
      this.selectedEntity = entity;
      if (this.exceptionType !== EXCEPTION_TYPE.INEGRATION) {
        const result = await this.$store.dispatch('order/getExceptionDetails',
          {
            entityNo: this.selectedEntity.entity_no,
            entityType: this.selectedEntity.entity_type,
          },
        );

        if (result) {
          this.entityDetails = result;
        } else {
          this.entityDetails = null;
          this.$error({ message: 'Invalid Request!' });
        }
      }
    },
    routeToIndentList() {
      this.$router.push({ path: '/indents/outbound' });
    },
  },
};
</script>
